// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1pVkX","row":"ProcedureTreatmentSummary_row__1Hcd8"};